import React from 'react';
import Icon from '../../../components/AppIcon';

const ViewToggle = ({ activeView, onViewChange }) => {
  return (
    <div className="flex gap-2 p-1 bg-muted rounded-lg">
      <button
        onClick={() => onViewChange('list')}
        className={`flex items-center gap-2 px-4 py-2 rounded-md transition-smooth ${
          activeView === 'list' ?'bg-card text-primary shadow-organic-sm' :'text-muted-foreground hover:text-foreground'
        }`}
        aria-label="Liste görünümü"
      >
        <Icon name="List" size={18} />
        <span className="text-sm md:text-base font-medium">Liste</span>
      </button>
      <button
        onClick={() => onViewChange('map')}
        className={`flex items-center gap-2 px-4 py-2 rounded-md transition-smooth ${
          activeView === 'map' ?'bg-card text-primary shadow-organic-sm' :'text-muted-foreground hover:text-foreground'
        }`}
        aria-label="Harita görünümü"
      >
        <Icon name="Map" size={18} />
        <span className="text-sm md:text-base font-medium">Harita</span>
      </button>
    </div>
  );
};

export default ViewToggle;